 
import TeamMember from "../../section/team/teamMember/TeamMember";
import data from "../../../assets/data/team/teamMembersV1";
import TeamStyleWrapper from "./Team.style";
import SectionTitle from "../../../common/sectionTitle";

const Team = () => {
  return (
    <TeamStyleWrapper>
      <div className="hermes_team_sect v1_team_sect" id="team">
        <div className="v1_team_overlay">
          <div className="container">
            <SectionTitle title="MEET THE TEAM" subtitle="TEAM MEMBERS" />
            <div className="hermes_team_content">
              <div className="row">
                {data?.map((member, i) => (
                  <div key={i} className="col-lg-3 col-md-4 col-sm-6">
                    <TeamMember {...member} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </TeamStyleWrapper>
  );
};

export default Team;
